import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { $createRangeSelection, $getRoot, $getSelection, $isRangeSelection, $setSelection, COMMAND_PRIORITY_EDITOR, KEY_ESCAPE_COMMAND, SELECTION_CHANGE_COMMAND, createCommand } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Icon } from "../../../../Icon/index.js";
import { ToolbarButton } from "../common/index.js";
const isFullSelection = (selection)=>{
    try {
        const root = $getRoot();
        const anchor = selection.anchor;
        const focus = selection.focus;
        const rootTextSize = root.getTextContentSize();
        const selectedTextSize = selection.getTextContent().length;
        return rootTextSize === selectedTextSize && 0 !== rootTextSize || anchor.key === root.getKey() && focus.key === root.getKey() && 0 === anchor.offset && focus.offset === root.getChildrenSize();
    } catch (unused) {
        return false;
    }
};
const TOGGLE_SELECT_ALL_COMMAND = createCommand();
const SelectAllPlugin = ()=>{
    const $ = c(21);
    const [editor] = useLexicalComposerContext();
    const [selectionState, setSelectionState] = useState("none");
    const isSelectAllActive = useRef(false);
    const lastSelectionRef = useRef(null);
    const isSelected = "full" === selectionState;
    let t0;
    if ($[0] !== editor) {
        t0 = ()=>{
            editor.dispatchCommand(TOGGLE_SELECT_ALL_COMMAND, void 0);
        };
        $[0] = editor;
        $[1] = t0;
    } else t0 = $[1];
    const handleClick = t0;
    let t1;
    let t2;
    if ($[2] !== editor || $[3] !== isSelected) {
        t1 = ()=>editor.registerCommand(TOGGLE_SELECT_ALL_COMMAND, ()=>{
                editor.update(()=>{
                    const root = $getRoot();
                    if (isSelectAllActive.current || isSelected) {
                        $setSelection(null);
                        isSelectAllActive.current = false;
                    } else {
                        const selection = $createRangeSelection();
                        selection.anchor.set(root.getKey(), 0, "element");
                        selection.focus.set(root.getKey(), root.getChildrenSize(), "element");
                        $setSelection(selection);
                        isSelectAllActive.current = true;
                    }
                });
                return true;
            }, COMMAND_PRIORITY_EDITOR);
        t2 = [
            editor,
            isSelected
        ];
        $[2] = editor;
        $[3] = isSelected;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    useEffect(t1, t2);
    let t3;
    let t4;
    if ($[6] !== editor) {
        t3 = ()=>editor.registerCommand(SELECTION_CHANGE_COMMAND, ()=>{
                editor.update(()=>{
                    const currentSelection = $getSelection();
                    if ($isRangeSelection(currentSelection)) {
                        if (currentSelection.isCollapsed()) isSelectAllActive.current = false;
                        lastSelectionRef.current = currentSelection.clone();
                    }
                });
                return false;
            }, COMMAND_PRIORITY_EDITOR);
        t4 = [
            editor
        ];
        $[6] = editor;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    useEffect(t3, t4);
    let t5;
    let t6;
    if ($[9] !== editor) {
        t5 = ()=>editor.registerCommand(KEY_ESCAPE_COMMAND, ()=>{
                if (isSelectAllActive.current) {
                    editor.update(_temp);
                    isSelectAllActive.current = false;
                    return true;
                }
                return false;
            }, COMMAND_PRIORITY_EDITOR);
        t6 = [
            editor
        ];
        $[9] = editor;
        $[10] = t5;
        $[11] = t6;
    } else {
        t5 = $[10];
        t6 = $[11];
    }
    useEffect(t5, t6);
    let t7;
    let t8;
    if ($[12] !== editor) {
        t7 = ()=>{
            const unsubscribe = editor.registerUpdateListener(()=>{
                editor.update(()=>{
                    const selection_0 = $getSelection();
                    if (!$isRangeSelection(selection_0)) return void setSelectionState("none");
                    if (isFullSelection(selection_0)) setSelectionState("full");
                    else selection_0.isCollapsed(), setSelectionState("none");
                });
            });
            return ()=>unsubscribe();
        };
        t8 = [
            editor
        ];
        $[12] = editor;
        $[13] = t7;
        $[14] = t8;
    } else {
        t7 = $[13];
        t8 = $[14];
    }
    useEffect(t7, t8);
    const t9 = isSelected ? "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435" : "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0451";
    const t10 = isSelected ? "original.brand.primary" : "text.light.primary";
    let t11;
    if ($[15] !== t10) {
        t11 = /*#__PURE__*/ jsx(Icon, {
            name: "text_viewfinder_outline",
            size: "16",
            color: t10
        });
        $[15] = t10;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== handleClick || $[18] !== t11 || $[19] !== t9) {
        t12 = /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: handleClick,
            tooltip: t9,
            children: t11
        });
        $[17] = handleClick;
        $[18] = t11;
        $[19] = t9;
        $[20] = t12;
    } else t12 = $[20];
    return t12;
};
function _temp() {
    return $setSelection(null);
}
export { SelectAllPlugin };
